 
 
 


  <div  class="member-detail-container">

    <div class="profile-back-button" (click)="goBack()">
      <img src="assets/imgs/back.svg" alt="back-arrow">
    </div>
    @if (user) {

    <div class="profile-body">

      <div class="profile-image-wrapper">
        @if (user.avatar) {
          <img class="profile-image"
          [src]="api + user.avatar"
          alt="profile">
        } @else {
          <img class="profile-image" src="assets/imgs/profile-image.png" alt="profile">
        }
        @if (user.status === 'industry') {
          <div class="industry-badge">INDUSTRY</div>
        }
      </div>
      <div class="profile-info">
        <div class="profile-name">
          {{user.fullName | uppercase}}
        </div>
        <div class="profile-company">
          {{user.company | uppercase}}
        </div>
        <div class="profile-type">
          @if (user.position === POSITIONS.OTHER) {
            {{user.additionalPosition}}
          } @else if(user.position === POSITIONS.SOUND_ENGINEER) {
            {{'Sound Engineer'}}
          } @else if(user.position === POSITIONS.LIGHT_DESIGNER) {
            {{'Light Designer'}}
          } @else {
            {{user.position}}
          }
        </div>
      </div>
     
        <div class="profile-country">
          @if (user.country && user.city) {
            {{user.country + ', ' + user.city}}
          } @else if(user.country) {
            {{user.country}}
          } @else if(user.city) {
            {{user.city}}
          }
        </div>
        <div class="profile-description">
          {{user.shortBio}}
        </div>
    
        <div class="list-detail-socials">
          @if (user.countryCode && user.mobile && shouldShowPhone()) {
              <a [appCopyClipboard]="user.countryCode+ ' ' + user.mobile" class="list-detail-socials-item-phone" >
              <img   class="list-detail-socials-item" src="assets/imgs/phone-icon.svg" alt="social-instagram">
            </a>
          }
          @if(user.email && shouldShowEmail()) {
                <a [appCopyClipboard]="user.email"  class="list-detail-socials-item-link" >
                  <img  class="list-detail-socials-item" src="assets/imgs/mail-icon.svg" alt="social-instagram">
            </a>
          }
          @if(user.instagram && shouldShowSocials()) {
            <a class="list-detail-socials-item-link" [href]="user.instagram" target="_blank">
              <img  class="list-detail-socials-item" src="assets/imgs/instagram-icon.svg" alt="social-instagram">
            </a>
          }
          @if (user.soundcloud && shouldShowSocials()) {
            <a class="list-detail-socials-item-link" [href]="user.soundcloud" target="_blank">
              <img class="list-detail-socials-item" src="assets/imgs/soundcloud-icon.svg" alt="social-soundcloud">
            </a>
          }
          @if (user.linkedin && shouldShowSocials()) {
            <a class="list-detail-socials-item-link" [href]="user.linkedin" target="_blank">
              <img class="list-detail-socials-item" src="assets/imgs/linkedin-icon.svg" alt="linkedin">
            </a>
          }
          @if (user.residentAdvisor && shouldShowSocials()) {
            <a  class="list-detail-socials-item-link" [href]="user.residentAdvisor" target="_blank">
              <img class="list-detail-socials-item" src="assets/imgs/ra-icon.svg" alt="social-ra">
            </a>
          }
          @if (user.website && shouldShowSocials()) {
            <a  class="list-detail-socials-item-link" [href]="user.website" target="_blank">
              <img class="list-detail-socials-item" src="assets/imgs/web-icon.svg" alt="web">
            </a>
          }
        </div>
      </div>
    }

  </div>



